import { filedsMapList } from './filedsMapList'
// import { VRangePicker } from '@/components/FormElements'
import VDatePicker from '@/components/FormElements/VDatePicker'

export const renderFun = {
  input(o) {
    if (o.field === 'title') {
      return (
        <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
          <a-form-model-item label={o.field_name} prop={o.field}>
            <div class="flex" style="height: 40px">
              <a-input vModel={this.form[o.field]} allowClear placeholder="请输入" />
              <a-button type="primary" style="margin-left: 15px" onClick={() => this.forbiddenWords('title')}>敏感词检测</a-button>
            </div>
            {
              this.titleHtml && <div domPropsInnerHTML={this.titleHtml}></div>
            }
          </a-form-model-item>
        </a-col>
      )
    }
    if (o.field === 'keywords' && this.hasKeyword && this.hasLabel) {
      return (
        <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
          <a-form-model-item label={o.field_name} prop={o.field}>
            <a-input vModel={this.form[o.field]} allowClear placeholder="请输入" style="width:60%; margin-right: 20px;" />
            <a-button type="primary" onClick={this.getTags}>获取推荐标签</a-button>
          </a-form-model-item>
        </a-col>
      )
    }
    if (o.field === 'recommended_tag') {
      return (
        <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
          <a-form-model-item label="推荐标签" prop={o.field}>
            <div class="tags-swapper">
              {
                this.tagList.map(tag => {
                  return <a-checkable-tag vModel={tag.checked} style="marign: 0px 3px;" onChange={this.chooseOneTag.bind(this, tag)} >{tag.label_name}</a-checkable-tag>
                })
              }
            </div>
          </a-form-model-item>
        </a-col>
      )
    }
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item label={o.field_name} prop={o.field}>
          <a-input vModel={this.form[o.field]} allowClear placeholder="请输入" />
        </a-form-model-item>
      </a-col>
    )
  },
  textarea(o) {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item label={o.field_name} prop={o.field}>
          <a-input vModel={this.form[o.field]} type="textarea" allowClear placeholder="请输入" />
        </a-form-model-item>
      </a-col>
    )
  },
  radio(o) {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item label={o.field_name} prop={o.field}>
          <a-radio-group vModel={this.form[o.field]}>
            {
              this[o.label].map(o => (
                <a-radio key={o.key} value={o.key}>{o.value}</a-radio>
              ))
            }
          </a-radio-group>
        </a-form-model-item>
      </a-col>
    )
  },
  select(o) {
    function renderOption(o) {
      let renderDom = null
      if (o.label) {
        renderDom = this[o.label].map(item => (
          <a-select-option key={item.key} value={item.key}>{item.value}</a-select-option>
        ))
      } else {
        renderDom = this[filedsMapList[o.field].list].map(item => (
          <a-select-option
            key={item[filedsMapList[o.field].value]}
            value={item[filedsMapList[o.field].value]}
          >{item[filedsMapList[o.field].label]}
          </a-select-option>
        ))
      }
      return renderDom
    }
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={10}>
        <a-form-model-item label={o.field_name} prop={o.field}>
          <a-select vModel={this.form[o.field]} style="width: 100%" allowClear show-search option-filter-prop="children" placeholder="请选择" onChange={this.changePlatform}>
            {renderOption.call(this, o)}
          </a-select>
        </a-form-model-item>
      </a-col>
    )
  },
  selectMult(o) {
    function renderOption(o) {
      let renderDom = null
      if (o.label) {
        renderDom = this[o.label].map(item => (
          <a-select-option key={item.key} value={item.key}>{item.value}</a-select-option>
        ))
      } else {
        renderDom = this[filedsMapList[o.field].list].map(item => (
          <a-select-option
            key={item[filedsMapList[o.field].value]}
            value={item[filedsMapList[o.field].value]}
          >{item[filedsMapList[o.field].label]}
          </a-select-option>
        ))
      }
      return renderDom
    }
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={12}>
        <a-form-model-item label={o.field_name} prop={o.field}>
          <a-select vModel={this.form[o.field]} mode='multiple' style="width: 100%" allowClear show-search option-filter-prop="children" placeholder="请选择" onChange={this.changePlatform}>
            {renderOption.call(this, o)}
          </a-select>
        </a-form-model-item>
      </a-col>
    )
  },
  selectSearch(o) {
    function renderOption(o) {
      let renderDom = null
      if (o.label) {
        renderDom = this[o.label].map(item => (
          <a-select-option key={item.key} value={item.key}>{item.value}</a-select-option>
        ))
      } else {
        renderDom = this[filedsMapList[o.field].list].map(item => (
          <a-select-option
            key={item[filedsMapList[o.field].value]}
            value={item[filedsMapList[o.field].value]}
          >{`${item[filedsMapList[o.field].label]}(${item.org})`}
          </a-select-option>
        ))
      }
      return renderDom
    }
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={18}>
        <a-form-model-item label-col={{ span: 3 }} label={o.field_name} prop={o.field}>
          <a-select
            value={this.form[o.field]}
            mode='multiple'
            show-search
            style="width: 100%"
            allowClear
            show-arrow={false}
            filter-option={false}
            not-found-content={[]}
            onSearch={this.handleLabelsSelectSearch}
            onChange={this.handleLabelsSelectChange}
          >
            {renderOption.call(this, o)}
          </a-select>
        </a-form-model-item>
      </a-col>
    )
  },
  upload(o) {
    function show() {
      return (
        <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">
            Upload
          </div>
        </div>
      )
    }
    function isCut() {
      return (
        <div style="padding-left: 20px">
          <a-upload
            accept=".jpg, .jpeg, .png"
            headers={{ token: this.token }}
            file-list={this[`${o.field}List`]}
            action={`${this.baseURL}/public/upload-file-qi-niu`}
            beforeUpload={(file) => this.handleBeforeUpload(file, o.field)}
            list-type="picture-card"
            onPreview={this.handlePreview}
            onChange={(data) => this.handleChange(o.field, data)}
          >
            {this[`${o.field}List`].length < 1 && show()}
          </a-upload>
          {o.field.includes('app') && <a-button style="margin-left: 20px;transform: translateY(-16px)" onClick={() => this.handleTailor(o.field)}>裁剪</a-button>}
        </div>
      )
    }
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item style="height: 150px" label={o.field_name} prop={o.field}>
          {isCut.call(this)}
        </a-form-model-item>
      </a-col>
    )
  },
  videoUpload(o) {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item style="height: 150px" label={o.field_name} prop={o.field}>
          <yzVideoUpload domains={this.QI_NIU_DOMAINS} maxSize={50} text={o.field_tip ? o.field_tip : undefined} headers={{ token: this.token }} number={o?.field_value?.[0]?.pic_num ?? 1} accept="video/*" vModel={this.form[o.field]} isMultiple={true} />
        </a-form-model-item>
      </a-col>
    )
  },
  cutPre(o) {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item style="height: 150px" label={o.field_name} prop={o.field}>
          <div class="flex-col" style="padding-left: 20px">
            {
              this.form[o.field] ? (
                <PreImg
                  src={`${this.QI_NIU_DOMAINS}/${this.form[o.field]}`}
                  onDelete={() => this.hadnleDeleteCut(o.field)}
                />
              ) : (
                <div class="img-default">
                  <a-icon type="picture" />
                </div>
              )
            }
            <span style="margin: 10px 0 0 30px">裁剪后</span>
          </div>
        </a-form-model-item>
      </a-col>
    )
  },
  editor(o) {
    return (
      <a-col span="24">
        <a-form-model-item label="内容" prop={o.field} label-col={{ span: 2 }} wrapper-col={{ span: 20 }}>
          <div class="flex">
            <Editor vModel={this.form[o.field]} style="width: 900px" />
            <div class="ml20">
              <a-button class="btn-color-warning" type="primary" onClick={() => this.forbiddenWords('content')}>敏感词检测</a-button>
              <div></div>
              <a-button class="btn-color-warning" type="primary" onClick={this.previewPcFn}>PC 预览</a-button>
              <div></div>
              <a-button class="btn-color-warning" type="primary" onClick={this.previewWapFn}>移动预览</a-button>
            </div>
          </div>

          {
            this.contentHtml && <div domPropsInnerHTML={this.contentHtml}></div>
          }
        </a-form-model-item>
      </a-col>
    )
  },
  datePicker(o) {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        <a-form-model-item label={o.field_name} prop={o.field}>
            <VDatePicker placeholder="请选择" format="YYYY-MM-DD" vModel={this.form[o.field]} />
        </a-form-model-item>
      </a-col>
    )
  }

}
